import { RetrieveEmailForm } from '../../forms/retrieve_email_form';

export default class View {
	constructor() {
        // stop if wrong page!
        if (!document.querySelector('.retrieve-email-container')) {
          return;
        }
        let container = document.querySelector('.facility-container');
        let form = document.querySelector('.retrieve-email-form');
        new RetrieveEmailForm(form, container, this);
    }
}
